































import Vue from 'vue';
import { API } from '@/api';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  components: {},
  props: {
    datos: Array,
    disabled: Boolean,
  },
  data: () => ({
    openDialog: false,
  }),
  methods: {
    async EliminarPropiet() {
      this.loading = true;
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      for (const prop of this.datos) {
        try {
          const datos = {adminId: admin.id, condoId: condo.id, propId: prop.id };
          console.debug('datos: %o', datos);
          const result = await this.$store.dispatch('deletePropietInquilino', datos);
          console.debug('EliminarPropietario/Inquilino: %o', result);
          this.$toast.success('Propietario/Inquilino borrado');
          this.$emit('reload');
        } catch (e) {
          this.$toast.error(e.response.data.message);
        }
      }
      // this.datos = [];
      this.openDialog = false;
      // this.reloadGrid();
      // this.$emit('reload', {});
    },
  },
});
